import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "gapSize"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { ButtonWrapper } from '../ButtonWrapper/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const ColorSquatchGridContainer = styled.div.withConfig({
  displayName: "ColorSquatchGrid__ColorSquatchGridContainer"
})(({
  $cssStyles
}) => {
  return Object.assign({}, $cssStyles);
});
export const ColorSquatchGrid = _ref => {
  let {
      children,
      gapSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(ColorSquatchGridContainer, Object.assign({
    $cssStyles: cssStyles
  }, domProps, {
    children: /*#__PURE__*/_jsx(ButtonWrapper, {
      "data-test-id": "button-wrapper",
      horizontalGap: gapSize,
      verticalGap: gapSize,
      children: children
    })
  }));
};
ColorSquatchGrid.displayName = 'ColorSquatchGrid';